<template>
  <div
    @click.self="closeFreebetsClone"
    class="fixed top-0 left-0 w-full h-full z-[123456789000] flex items-center justify-center bg-gray-900/40 backdrop-blur-sm p-2 sm:p-4"
  >
    <div
      class="bg-white w-full max-w-4xl rounded-2xl shadow-xl flex flex-col max-h-[95vh] overflow-hidden border border-gray-200"
    >
      <div
        class="px-3 py-3 border-b border-gray-100 flex items-center justify-between bg-white"
      >
        <div class="flex items-center gap-2.5">
          <div>
            <h2 class="text-base font-semibold text-gray-800 leading-tight">
              Clone Freebets
            </h2>
            <p
              class="text-[12px] text-gray-400 font-medium uppercase tracking-tight"
            >
              Duplicate configuration
            </p>
          </div>
        </div>
        <button
          @click="closeFreebetsClone"
          class="p-1.5 hover:bg-gray-100 rounded-full text-gray-400 transition-colors"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-4 space-y-5">
        <template v-if="!uploadingFreebetClones">
          <section class="space-y-2">
            <h3
              class="text-[12px] font-semibold text-slate-600 uppercase tracking-widest flex items-center gap-1.5 ml-1"
            >
              <span class="w-1 h-3 bg-[#386f99] rounded-full"></span> Single
              Clone
            </h3>
            <div
              class="grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] items-end gap-2 p-3 bg-gray-50/50 rounded-xl border border-gray-100"
            >
              <div class="space-y-1">
                <label
                  class="text-[11px] font-semibold text-slate-500 uppercase ml-1"
                  >Start Date & Time</label
                >
                <input
                  type="datetime-local"
                  v-model="startAt"
                  class="w-full px-3 custom-input py-1.5 bg-white border border-gray-200 rounded-lg text-xs focus:ring-2 focus:ring-indigo-500/10 outline-none"
                />
              </div>
              <div class="space-y-1">
                <label
                  class="text-[11px] font-semibold text-slate-500 uppercase ml-1"
                  >End Date & Time</label
                >
                <input
                  type="datetime-local"
                  v-model="endAt"
                  class="w-full custom-input px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs focus:ring-2 focus:ring-indigo-500/10 outline-none"
                />
              </div>
              <button
                @click="addClone"
                class="bg-[#386f99] text-white p-2 rounded-full transition-all active:scale-95 h-[34px] flex items-center justify-center shadow-sm"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="3"
                >
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
              </button>
            </div>
          </section>

          <section class="space-y-2">
            <h3
              class="text-[12px] font-semibold text-slate-600 uppercase tracking-widest flex items-center gap-1.5 ml-1"
            >
              <span class="w-1 h-3 bg-[#386f99] rounded-full"></span> Range
              Clone
            </h3>
            <div
              class="p-3 bg-gray-50/50 rounded-xl border border-gray-100 space-y-3"
            >
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div class="space-y-1">
                  <label
                    class="text-[11px] font-semibold text-slate-500 uppercase ml-1"
                    >Date Range (From/To)</label
                  >
                  <div class="flex items-center gap-1">
                    <input
                      type="date"
                      v-model="rangesDateInterval[0]"
                      class="w-full custom-input px-2 py-1.5 bg-white border border-gray-200 rounded-lg text-xs outline-none"
                    />
                    <input
                      type="date"
                      v-model="rangesDateInterval[1]"
                      class="w-full custom-input px-2 py-1.5 bg-white border border-gray-200 rounded-lg text-xs outline-none"
                    />
                  </div>
                </div>
                <div class="space-y-1">
                  <label
                    class="text-[11px] font-semibold text-slate-500 uppercase ml-1"
                    >Daily Time Slots</label
                  >
                  <div class="flex items-center gap-1">
                    <input
                      type="time"
                      v-model="startHour_start"
                      class="w-full custom-input px-2 py-1.5 bg-white border border-gray-200 rounded-lg text-xs outline-none"
                    />
                    <input
                      type="time"
                      v-model="endHour_end"
                      class="w-full custom-input px-2 py-1.5 bg-white border border-gray-200 rounded-lg text-xs outline-none"
                    />
                  </div>
                </div>
              </div>
              <button
                @click="addCloneForRange"
                class="w-full py-1.5 bg-[#386f99] text-white rounded-lg text-[11px] font-semibold uppercase tracking-wider transition-all flex items-center justify-center gap-2 shadow-sm"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="3"
                >
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                Add Range
              </button>
            </div>
          </section>

          <section v-if="clones.length > 0" class="space-y-2">
            <div class="flex items-center justify-between px-1">
              <h3 class="text-[12px] font-semibold text-gray-400 uppercase">
                Freebets ready to be cloned ({{ clones.length }})
              </h3>
              <button
                @click="clones = []"
                class="text-[11px] font-semibold text-red-500 hover:text-red-600 uppercase transition-colors"
              >
                Clear All
              </button>
            </div>
            <div
              class="space-y-1 max-h-[180px] overflow-y-auto pr-1 custom-scrollbar"
            >
              <div
                v-for="(clone, index) in clones"
                :key="index"
                class="flex items-center justify-between p-2 bg-white border border-gray-100 rounded-lg group hover:border-indigo-200 transition-all"
              >
                <div class="flex items-center gap-3">
                  <span class="text-[12px] font-semibold text-slate-500"
                    >#{{ index + 1 }}</span
                  >
                  <div class="flex items-center gap-2 text-[11px]">
                    <span class="font-medium text-gray-700">{{
                      formatDate(clone.start_at)
                    }}</span>
                    <svg
                      class="text-slate-500"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                    <span class="font-medium text-gray-700">{{
                      formatDate(clone.end_at)
                    }}</span>
                  </div>
                </div>
                <button
                  @click="removeClone(index)"
                  class="p-1 text-slate-500 hover:text-red-500 transition-colors"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path d="M3 6h18"></path>
                    <path
                      d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </section>
        </template>

        <div
          v-else
          class="py-8 flex flex-col items-center justify-center space-y-3"
        >
          <div
            class="w-10 h-10 border-[3px] border-[#386f99] border-t-transparent rounded-full animate-spin"
          ></div>
          <div class="text-center">
            <p
              class="text-[11px] font-semibold text-gray-800 uppercase tracking-widest"
            >
              Processing
            </p>
            <p class="text-[12px] text-gray-400">
              Creating clones, please wait...
            </p>
          </div>
        </div>
      </div>

      <div class="px-5 py-3 bg-gray-50 border-t border-gray-100 flex gap-2">
        <button
          @click="closeFreebetsClone"
          class="flex-1 py-2 border border-gray-200 rounded-xl text-[11px] font-semibold text-slate-500 uppercase hover:bg-white hover:text-gray-700 transition-all"
        >
          Cancel
        </button>
        <button
          @click="submitClones"
          :disabled="clones.length === 0 || uploadingFreebetClones"
          class="flex-[2] py-2 bg-green-600 text-white rounded-xl text-[11px] font-semibold uppercase tracking-wider shadow-lg disabled:opacity-20 disabled:grayscale transition-all active:scale-[0.98]"
        >
          {{
            uploadingFreebetClones
              ? "Processing..."
              : `Confirm (${clones.length})`
          }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { postFetch } from "@/api/axiosClient";
import Loader from "./Loader.vue";
import { min } from "date-fns";

export default {
  name: "FreebetCloneManager",
  props: {
    closeFreebetsClone: Function,
    detail: {
      type: Object,
      required: true,
    },
  },
  components: {
    FlatPickr,
    Loader,
  },
  data() {
    return {
      startAt: this.formatDate2(this.detail?.start_at || new Date()),
      endAt: this.formatDate2(this.detail?.end_at || new Date()),
      clones: [],
      rangesDateInterval: [this.getFormattedDate(0), this.getFormattedDate(7)],
      startHour_start: this.getHourMinutes(this.detail?.start_at || new Date()),
      endHour_end: this.getHourMinutes(this.detail?.end_at || new Date()),
      startDateConfig: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        theme: "dark",
        minDate: this.detail.start_at,
      },
      rangesDate: {
        mode: "range",
        dateFormat: "Y-m-d",
        time_24hr: true,
        minDate: "today",
        showMonths: 2,
        locale: {
          firstDayOfWeek: 1,
        },
      },
      endDateConfig: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        theme: "dark",
        minDate: this.detail.start_at || new Date(),
      },
      uploadingFreebetClones: false,
    };
  },
  computed: {
    ...mapGetters(["isMenuOpen"]),
  },
  methods: {
    formatDate2(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    getFormattedDate(daysToAdd) {
      const date = new Date();
      date.setDate(date.getDate() + daysToAdd);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    convertToDate(date) {
      const convertedDate = new Date(date);
      return isNaN(convertedDate) ? null : convertedDate;
    },
    formatDate(date) {
      return new Date(date).toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getHours()}:${now.getMinutes()}`;
    },
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    getHourMinutes(date) {
      if (!date) return "";
      const d = new Date(date);
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    updateMinEndDate() {
      this.endDateConfig.minDate = this.startAt;
    },

    checkOverlap(newStart, newEnd) {
      return this.clones.some((clone) => {
        const cloneStart = new Date(clone.start_at);
        const cloneEnd = new Date(clone.end_at);

        return newStart < cloneEnd && newEnd > cloneStart;
      });
    },

    addClone() {
      if (!this.startAt || !this.endAt) {
        Swal.fire({
          icon: "error",
          title: "Missing Dates",
          text: "Please select both start and end dates.",
        });
        return;
      }

      const newStart = new Date(this.startAt);
      const newEnd = new Date(this.endAt);

      if (newStart >= newEnd) {
        Swal.fire({
          icon: "error",
          title: "Invalid Date Range",
          text: "The start date must be before the end date.",
        });
        return;
      }

      if (
        newStart.getTime() === new Date(this.detail.start_at).getTime() &&
        newEnd.getTime() === new Date(this.detail.end_at).getTime()
      ) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Date Error",
          text: "The selected date range matches the original freebet. Please choose a different range.",
        });
        return;
      }

      if (this.checkOverlap(newStart, newEnd)) {
        Swal.fire({
          icon: "error",
          title: "Overlap Error",
          text: "The selected date range overlaps with an existing clone.",
        });
        return;
      }

      const isDuplicate = this.clones.some((clone) => {
        const cloneStart = new Date(clone.start_at);
        const cloneEnd = new Date(clone.end_at);
        return (
          cloneStart.getTime() === newStart.getTime() &&
          cloneEnd.getTime() === newEnd.getTime()
        );
      });

      if (isDuplicate) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Clone",
          text: "A clone with the same start and end dates already exists.",
        });
        return;
      }

      this.clones.push({
        ...this.detail,
        start_at: this.startAt,
        end_at: this.endAt,
        created_at: new Date().toISOString().replace("T", " ").substring(0, 19),
        code: this.detail.code ?? 1,
      });
    },

    addCloneForRange() {
      if (!this.startHour_start || !this.endHour_end) {
        Swal.fire({
          icon: "error",
          title: "Missing Time",
          text: "Please select both start and end times.",
        });
        return;
      }

      const startDate = new Date(this.rangesDateInterval[0]);
      const endDate = new Date(this.rangesDateInterval[1]);

      if (startDate > endDate) {
        Swal.fire({
          icon: "error",
          title: "Date error",
          text: "Start must be before End!",
        });
        return;
      }

      const clonesToAdd = [];
      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split("T")[0];

        const start_at = `${formattedDate} ${this.startHour_start}`;
        const end_at = `${formattedDate} ${this.endHour_end}`;
        clonesToAdd.push({
          ...this.detail,
          start_at: start_at,
          end_at: end_at,
          created_at: new Date()
            .toISOString()
            .replace("T", " ")
            .substring(0, 19),
          code: this.detail.code ?? 1,
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }
      const newClones = clonesToAdd.filter((newClone) => {
        return !this.clones.some((existingClone) => {
          return (
            new Date(existingClone.start_at).getTime() ===
              new Date(newClone.start_at).getTime() &&
            new Date(existingClone.end_at).getTime() ===
              new Date(newClone.end_at).getTime()
          );
        });
      });

      if (newClones.length === 0) {
        Swal.fire({
          title: "No New Clones Added",
          text: "All selected dates already exist as clones.",
        });
        return;
      }

      this.clones.push(...newClones);

      Swal.fire({
        title: "Clones Created",
        text: `${newClones.length} new freebets added successfully.`,
      });
    },
    removeClone(index) {
      this.clones.splice(index, 1);
    },
    async submitClones() {
      this.uploadingFreebetClones = true;
      try {
        for (let i = 0; i < this.clones.length; i++) {
          let formData = this.clones[i];

          try {
            await postFetch("freebets", formData);
            await new Promise((resolve) => setTimeout(resolve, 400));
          } catch (error) {
            console.error(`Error uploading clone #${i + 1}:`, error);
            Swal.fire({
              title: "Error!",
              text: `An error occurred while creating the freebet clone #${
                i + 1
              }.`,
              icon: "error",
            });
          }
        }
        await Swal.fire({
          title: "Success!",
          text: "All freebet clones have been uploaded successfully.",
        });

        window.location.href = "/freebets";
      } catch (error) {
        console.error("Error during the cloning process:", error);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while creating the freebet clones. Please check the process.",
          icon: "error",
        });
      } finally {
        this.uploadingFreebetClones = false;
      }
    },
  },
  mounted() {
    import("@/assets/styles/components/flatPickerv2.scss");
  },
  beforeUnmount() {
    const styleElement = document.querySelector(
      "link[href='@/assets/styles/components/flatPickerv2.scss']",
    );
    if (styleElement) {
      styleElement.remove();
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-input {
  @apply w-full px-3 py-2 rounded-xl border border-slate-200 focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500 transition-all outline-none text-black;
}

ul::-webkit-scrollbar {
  width: 4px;
}
ul::-webkit-scrollbar-track {
  background: transparent;
}
ul::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

select,
input {
  color: black;
}
</style>
